import { c as _c } from "react/compiler-runtime";
import { Typography, DirectionIcon } from "@/shared/ui/atoms";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";
const BannerTreatmentCase = () => {
  const $ = _c(18);
  const t = useTranslations();
  const locale = useLocale();
  const t0 = `/${locale}/entry-form`;
  let t1;
  if ($[0] !== t) {
    t1 = t("bannerTreatmentCase.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Typography size={15} lineHeight={21} className="text-gray-900 font-semibold">{t1}</Typography>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("bannerTreatmentCase.description");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Typography size={15} lineHeight={21} className="text-gray-900 font-medium">{t3}</Typography>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("bannerTreatmentCase.button");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DirectionIcon size={16} className="text-[#3449FF]" rotate={270} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className="flex items-center gap-1 mt-1.5 text-[#3449FF]">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t0 || $[14] !== t2 || $[15] !== t4 || $[16] !== t7) {
    t8 = <Link href={t0} prefetch={false} className="w-full flex flex-col items-start py-[13px] pl-4 justify-center cursor-pointer bg-[url('/banners/banner-treatment-case-bg.png')] bg-cover bg-center bg-no-repeat rounded-lg overflow-hidden">{t2}{t4}{t7}</Link>;
    $[13] = t0;
    $[14] = t2;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default BannerTreatmentCase;